"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersEndpoints = void 0;
const get_beta_tester_status_endpoint_1 = require("root/src/shared/users/endpoints/get-beta-tester-status.endpoint");
const transform_to_creator_endpoint_1 = require("root/src/shared/users/endpoints/transform-to-creator.endpoint");
exports.usersEndpoints = Object.assign(Object.assign({}, get_beta_tester_status_endpoint_1.getBetaTesterStatus), transform_to_creator_endpoint_1.transformToCreatorEndpoint);
